export default {
    data() {
        return {
            rpg_id: 0,
            select_options: {edu_progs: [], years: [], edu_profs: [], curriculum: [], departments: [], software: [], rpg_samples: []},
            text_info: {structure: "", subject: "", order_execution: "", order_def: "", order_examination: "", criteria: "", criteria_gos: "", literature_gos: "", literature: "", preamble_comp: ""},
            rpg_competitions: { UK: [], OPK_cat: [], OPK: [], PK: [], DPK: []},
            actives_type: {actives: "", tasks: ""},
            main_info: {
                speciality: "",
                speciality_code: "",
                profile: "",
                quality: "",
                year: "",
                edu_form: "",
                creator: {fio: "Фасахов Тимур Ирикович", position: "", title: ""},
                facility: "",
                department: "",
                dep_manager: "",
                grad_dep: "",
                approval_date: "",
                protocol_num: "",
                provisor: "",
                basis: "",
                basis_date: "",
                basis_num: "",
                doc_type: "Государственная итоговая аттестация",
                hour: 0.0,
                zet: 0.0,
            },
            doc_types: ['Государственная итоговая аттестация', 'ПРОГРАММА ИТОГОВОЙ АТЕСТАЦИИ', 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ' ],
            discipline: [{name:"", work: [{stage:"", content: "", course: "", control: ""}]}],
        }
    },
    methods: {
        AddUKCompetition(){
            this.rpg_competitions.UK.push({info: {}, text: ""})
        },
        DelUKCompetition(index){
            this.rpg_competitions.UK.splice(index, 1)
        },
        AddOPKCatCompetition(){
            this.rpg_competitions.OPK_cat.push({info: {}, text: ""})
        },
        DelOPKCatCompetition(index){
            this.rpg_competitions.OPK_cat.splice(index, 1)
        },
        AddOPKCompetition(){
            this.rpg_competitions.OPK.push({name:"", text: ""})
        },
        DelOPKCompetition(index){
            this.rpg_competitions.OPK.splice(index, 1)
        },
        AddPKCompetition(){
            this.rpg_competitions.PK.push({name:"", text: ""})
        },
        DelPKCompetition(index){
            this.rpg_competitions.PK.splice(index, 1)
        },
        AddDPKCompetition(){
            this.rpg_competitions.DPK.push({name:"", text: ""})
        },
        DelDPKCompetition(index){
            this.rpg_competitions.DPK.splice(index, 1)
        },
        AddWork(index){
            this.discipline[index].work.push({stage:"", content: "", course: "", control: ""})
        },
        DelWork(index_discipline, index_work){
            this.discipline[index_discipline].work.splice(index_work, 1)
        },
        AddStage(){
            this.discipline.push({name: "", work: []})
        },
        DelStage(index){
            this.discipline.splice(index, 1)
        }
    }
}